const Diamond = ({fill, width = 4}: {fill: string; width?: number}) => (
  <svg width={width} height={width} viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="">
    <g clipPath="url(#clip0_134_27065)">
      <path
        d="M0.283631 2.28363C0.126986 2.12699 0.126986 1.87301 0.28363 1.71637L1.71637 0.28363C1.87301 0.126986 2.12699 0.126986 2.28363 0.283631L3.71637 1.71637C3.87301 1.87301 3.87301 2.12699 3.71637 2.28363L2.28363 3.71637C2.12699 3.87301 1.87302 3.87302 1.71637 3.71637L0.283631 2.28363Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_134_27065">
        <rect width="4" height="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Diamond
